import LegalPage from "../components/LegalPage";

const SECTIONS = [
  {
    h: "What we collect",
    ps: [
      "When you send a group inquiry through barverse.com, we collect the details you provide: your name, email address, phone number, preferred Barverse location, event date, estimated guest count, event type and any message you include.",
      "We do not sell your personal information, and we do not use it for advertising lists.",
    ],
  },
  {
    h: "How we use it",
    ps: [
      "Group inquiry details are sent to the Barverse team and used for one purpose: following up on your event request. If you ask us not to contact you, we will honor that.",
    ],
  },
  {
    h: "Cookies & analytics",
    ps: [
      "This site uses only the technical essentials required to serve pages and remember your preferences. We do not run third-party ad tracking.",
    ],
  },
  {
    h: "Third-party links",
    ps: [
      "Links to tacoverse.com (including its menu and ordering pages) lead to a separate website operated by the Tacoverse brand. That site has its own privacy practices.",
    ],
  },
  {
    h: "Alcohol & age",
    ps: [
      "Barverse is a bar environment. You must be 21 or older to purchase or consume alcoholic beverages in the United States.",
    ],
  },
  {
    h: "Contact",
    ps: [
      "Privacy questions or requests about your data can go to info@tacoverse.com.",
    ],
  },
];

export default function Privacy() {
  return (
    <LegalPage
      testid="privacy-page"
      path="/privacy"
      title="Privacy"
      description="How barverse.com handles the information you share through group inquiries and general contact."
      updated="October 2026"
      intro="This is a focused brand website, so this policy is short: we only collect what a group inquiry needs, and we only use it to answer you."
      sections={SECTIONS}
    />
  );
}
